const config = {
    baseUrl: '/',   
     //~ apiUrl: "http://localhost:3008/api",
	 //~ imageUrl: 'http://localhost:3008/api/uploads/',
     //~ domainImg:'http://localhost:3008/api/domains/',
     //~ bannersUrl: 'http://localhost:3008/api/banners/',
     //~ mail_images:'http://localhost:3008/api/mail_images/',
    apiUrl : "https://apis.bondiclassifieds.com.au/api",
    adImgUrl: 'https://apis.bondiclassifieds.com.au/api/items/',
    mageUrl: 'https://apis.bondiclassifieds.com.au/api/uploads/',
    bannersUrl: 'https://apis.bondiclassifieds.com.au/api/banners/',
    domainImg:'http://apis.bondiclassifieds.com.au/api/domains/',
    mail_images:'http://apis.bondiclassifieds.com.au/api/mail_images/',
    superAdmin: 1,
    paging_size: 50
}
export default config;
